import { civilities, IndividualPersonType } from "../../static/types/commonTypes/individualType"
import PostalCodeField from "./PostalCodeField"
import useValidation from "../../hooks/useValidation"
import individualValidationSchema from "../../utils/validation/individualValidationSchema"
import { useEffect } from "react"
import useAppContext from "../../hooks/useAppContext"
import { AppContextType } from "../../context/AppContext"

type individualProps = {
    checked: boolean,
    individual: IndividualPersonType,
    changeIndividual: ( partialIndividual: Partial<IndividualPersonType> ) => void,
    onValidationChange: ( isValid: boolean ) => void,
    draftFieldName?: string
}

export default function IndividualPerson ({
    checked,
    individual,
    changeIndividual,
    onValidationChange,
    draftFieldName
}: individualProps ) {
      
    const {
        draftFormData, setDraftFormData
    } = useAppContext() as AppContextType
    
    const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
    const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }

    const { errors, isValid } = useValidation( individual, individualValidationSchema )

    useEffect( () => {
        onValidationChange( isValid )

        if( draftFieldName ){
            const draft = parseDraft()
            const tempDraft = { ...draft, [ draftFieldName ]: individual }
            setDraftFormData( stringifyDraft( tempDraft ))
        }

    }, [ isValid, onValidationChange ])

    return(
        <div className = "mb-3 row">

            <div className = "mb-3 row">

                <label htmlFor = "civility" className = "col-sm-2 col-form-label"> Civilité <strong className="text-danger">*</strong>  </label>

                <div className = "col-sm-10">

                    <select
                        className = { `form-control ${ ( checked && errors.civility ) ? 'is-invalid' : ''}` }
                        name = "civility"
                        id = "civility"
                        value = { individual.civility }
                        onChange = { event => changeIndividual({ civility: event.target.value as "Monsieur" | "Madame" } )}
                    >
                        {
                            civilities.map( option => 
                                <option key = { option } value = {option}>
                                    {option}
                                </option>
                            )
                        }

                    </select>
                    {  ( checked && errors.civility ) && <div className="invalid-feedback"> { errors.civility } </div> }

                </div>

            </div>

            <div className = "mb-3 row">

                <label htmlFor = "lastName" className = "col-sm-2 col-form-label">Nom <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-4">

                    <input
                        className = { `form-control ${ ( checked && errors.lastName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "nom"
                        id = "lastName"
                        value = { individual.lastName }
                        onChange = { event => changeIndividual({ lastName: event.target.value })}

                    />
                    {  ( checked && errors.lastName ) && <div className="invalid-feedback"> { errors.lastName } </div> }

                </div>

                <label htmlFor = "firstName" className = "col-sm-2 col-form-label">Prénom <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-4">

                    <input
                        className = { `form-control ${ ( checked && errors.firstName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "firstName"
                        value = { individual.firstName }
                        onChange = { event => changeIndividual({ firstName: event.target.value })}
                    />
                    {  ( checked && errors.firstName ) && <div className="invalid-feedback"> { errors.firstName } </div> }

                </div>

            </div>

            <div className = "mb-3 row">

                <label htmlFor = "address" className = "col-sm-2 col-form-label">Adresse <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-4">

                    <input
                        className = { `form-control ${ ( checked && errors.address ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "address"
                        id = "address"
                        value = { individual.address }
                        onChange = { event => changeIndividual({ address: event.target.value }) }
                    />
                    {  ( checked && errors.address ) && <div className="invalid-feedback"> { errors.address } </div> }

                </div>

                <label htmlFor = "additionalAddress" className = "col-sm-2 col-form-label">Adresse suite</label>
                
                <div className = "col-sm-4">
                    <input
                        className = "form-control"
                        type = "text"
                        name = "additionalAddress"
                        value = { individual.additionalAddress }
                        onChange = { event => changeIndividual({ additionalAddress: event.target.value })}
                    />
                </div>

            </div>

            <div className = "mb-3 row">

                <PostalCodeField
                    checked = { checked }
                    onChange = { changeIndividual }
                    postalCode = { individual.postalCode }
                    errors = { errors }
                    style={ { width: "100%", gap: "4px" } }
                />

                <label htmlFor = "city" className = "col-sm-2 col-form-label">Ville <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-4">

                    <select
                        className = { `form-control ${ ( checked && errors.city ) ? 'is-invalid' : ''}` }
                        name = "city"
                        id = "city"
                        onChange = { event => changeIndividual({ city: event.target.value }) }
                    >
                        {
                            individual.cities?.map( ( city, key )  => 
                                <option key = { key } value = { city }>
                                    { city }
                                </option>
                            )
                        }
                    </select>
                    {  ( checked && errors.city ) && <div className="invalid-feedback"> { errors.city } </div> }

                </div>
            </div>

        </div>
    )
}